import { Dropdown } from 'react-bootstrap';

const DropDown = ({
  label,
  name,
  displayName,
  isRequired,
  placeholder,
  value,
  defaultValue,
  handleSelect,
  options,
  optionKeys,
  errormsg,
  disabled,
  fieldFlag,
}) => {
  let optionId = 'id';
  let optionValue = 'displayName';
  if (optionKeys && optionKeys.length > 1) {
    optionId = optionKeys[0];
    optionValue = optionKeys[1];
  }
  return (
    <>
      <label htmlFor={name}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      <Dropdown
        onSelect={(val, e) => handleSelect(val, e, name, displayName, fieldFlag)}
        disabled={disabled}
      >
        <Dropdown.Toggle
          variant="success"
          name={name}
          id={'dropdown-' + name}
          className="dropdown-basic"
          disabled={disabled}
        >
          {value
            ? value
            : defaultValue
              ? defaultValue
              : placeholder
                ? placeholder
                : 'Select ' + label}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {options?.map((data) => (
            <Dropdown.Item
              key={optionKeys == null ? data : data[optionId]}
              eventKey={optionKeys == null ? data : data[optionId]}
            >
              {optionKeys == null ? data : data[optionValue]}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      {errormsg && <div className="error-message">{errormsg}</div>}
    </>
  );
};

export default DropDown;
